// extracted by mini-css-extract-plugin
module.exports = {"summaryActions":"SummaryActions__summaryActions__TlcAq","autoinvestRadio":"SummaryActions__autoinvestRadio__akMYx","widthSell":"SummaryActions__widthSell__07siA"};